import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { placeFilesSearchFragment } from "@/features/office/_components/file-library/file-library-search-fragment";
import { PlaceDetail } from "@/features/office/places/detail";
import { listItemsSearchFragment } from "@/features/office/places/detail/main/list-items/list-items-search-fragment";
import { maskSearchFragment } from "@/features/shared/route-masking";

const querySchema = z.object({
  "place-tab": z.string().optional(),
  "place-aside": z.string().optional(),
  "place-detail-id": z.string().optional(),
  "list-item-id": z.string().optional(),
  "space-id": z.string().optional(),
  "task-id": z.string().optional(),
  // The Lists tab's view, filters (Type and Proposed by) and done-or-archived toggle.
  ...listItemsSearchFragment,
  // The Digital Nest tab's open room, system, item or section (a Nest key).
  "nest-node": z.string().optional(),
  // The Digital Nest tab's view of the home's parts: `map`, or the list when absent.
  "nest-view": z.string().optional(),
  // The Files tab's search, filters and display options.
  ...placeFilesSearchFragment,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/office/places/$placeId")({
  component: PlaceDetail,
  validateSearch: querySchema,
});
